"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStudyDayWindow = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../helpers/type_validation_helpers");
const iso_date_string_types_1 = require("./iso_date_string_types");
const StudyDayWindowSchema = zod_1.z.object({
    from: iso_date_string_types_1.IsoDateStringSchema,
    isBeforeDailyWindowStart: zod_1.z.boolean(),
    to: iso_date_string_types_1.IsoDateStringSchema,
});
exports.isStudyDayWindow = type_validation_helpers_1.getTypeValidationFunction(StudyDayWindowSchema);
//# sourceMappingURL=daily_reset_types.js.map